module.exports = __webpack_public_path__ + "static/media/AccountLogout.7eacdbda.svg";